import RootRefContext from './context'

export default RootRefContext.Consumer
